import pageLocker from './page-locker';

export { pageLocker };
